import { Link } from 'react-router-dom'
import { decodeEntities } from './decodeEntities'

export default function renderMentions(text) {
  if (!text) return text
  // Decode server-side stripHtml entity-encoding for display (TEXT sink).
  // Entities aren't word chars, so this does not affect @mention detection.
  const decoded = decodeEntities(text)
  const parts = decoded.split(/(@[a-zA-Z0-9_]{2,30})\b/)
  return parts.map((part, i) => {
    if (part.startsWith('@')) {
      const username = part.slice(1)
      return <Link key={i} to={`/user/${username}`} className="wall-mention" onClick={e => e.stopPropagation()}>{part}</Link>
    }
    return part
  })
}
